<template>
  <div class="pages" v-cloak>
    <headerView :show-bg="true"></headerView>
    <div class="topseat">
      <i class="el-icon-location-outline"></i>
      <span>{{ $t("top_txt_seat") }}</span>
      <span v-for="(item, index) in seatList" :key="index">
        <i class="el-icon-arrow-right"></i>
        <span>{{ item }}</span>
      </span>
    </div>
    <div class="w960" v-if="spuData && spuData.spu">
      <div class="row container">
        <div id="goodsZoom">
          <div id="zoomTop">
            <!--        小图框-->
            <div
              id="smallPic"
              @mouseover="handlerMouseOver"
              @mouseleave="handlerMouseLeave"
              @mousemove="handlerMouseMove"
            >
              <img :src="smallImgSrc" />
              <!-- 蒙版元素-->
              <div id="mask" v-show="show"></div>
            </div>
            <!-- 大图框-->
            <div id="bigPic" v-show="show">
              <img :src="bigImgSrc" id="bigImg" />
            </div>
          </div>

          <div id="zoomBottom" class="clearfix">
            <a href="javascript:;" class="prev" @click="handlerPrev">
              <i class="el-icon-arrow-left"></i>
            </a>
            <div id="picList">
              <ul>
                <li
                  v-for="(item, index) in spuData.BannerImgList"
                  @click="thumbnailClick(item, index)"
                  :key="index"
                  :class="{ active: index == imgActive }"
                >
                  <img :src="item.masterUrl" />
                </li>
              </ul>
            </div>
            <a href="javascript:;" class="next" @click="handlerNext">
              <i class="el-icon-arrow-right"></i>
            </a>
          </div>
        </div>

        <div class="goodsWrods">
          <div>
            <div class="goodsName">{{ spuData.spu.name }}</div>
            <div class="goodsRefer">
              <!-- {{ spuData.spu.desc }} -->
                <pre v-html="spuData.spu.desc" v-if="spuData.spu.desc"></pre>
            </div>
          </div>
          <div class="row oper">
            <button class="btn">{{ $t("pay_txt") }}</button>
            <a
              :href="spuData.spu.docFileUrl"
              :download="spuData.spu.docFileName"
              class="row items-center pointer down c-black"
              v-if="spuData.spu.docFileUrl"
            >
              <img class="img" src="@/assets/images/download.png" />
              <span>{{ $t("manual_txt") }}</span>
            </a>
          </div>
        </div>
      </div>

      <div class="goodsDetail">
        <div class="rowCenter title">{{ $t("goods_detail_1") }}</div>
        <el-table
          v-if="
            spuData.spu.parameterTable && spuData.spu.parameterTable.length > 0
          "
          :data="spuData.spu.parameterTable"
          border
          class="tm-table-body"
          style="width: 100%"
        >
          <el-table-column
            prop="label"
            :label="$t('goods_detail_2')"
          ></el-table-column>
          <el-table-column
            prop="value"
            :label="$t('goods_detail_3')"
          ></el-table-column>
        </el-table>
        <div style="margin-top: 10px">
          <pre v-html="spuData.spu.detail" v-if="spuData.spu.detail"></pre>
        </div>

        <div class="column items-center detail" style="margin-top: 10px">
          <img
            :src="item.masterUrl"
            style="width: 100%; display: block"
            v-for="(item, index) in spuData.DetailImgList"
            :key="index"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSpuDetail } from "@/request/api";
import { mapGetters } from "vuex";
export default {
  name: "goods-magnifier-zoom",
  components: {},
  data() {
    return {
      show: false, //是否显示
      bigImgSrc: "",
      smallImgSrc: "",
      imgActive: 0,
      start: 0,
      prevShow: false,
      spuData: {},
      seatList: [],
    };
  },
  computed: {
    ...mapGetters(["categoryObj"]),
  },
  created() {
    if (this.$route.query) {
      this.$route.query.id && this.fetchData(this.$route.query.id);
    }
  },
  methods: {
    fetchData(id) {
      let that = this;
      that.stateSche = 1;
      getSpuDetail("spuId=" + id).then((res) => {
        if (res.code == 200 && res.data) {
          let data = res.data;
          let spuImageList = data.spuImageList || [];
          data.BannerImgList = [];
          data.DetailImgList = [];
          spuImageList.forEach((item) => {
            item.isMain == 1
              ? data.BannerImgList.push(item)
              : data.DetailImgList.push(item);
          });

          data.spu.parameterTable = data.spu.parameterTable
            ? JSON.parse(data.spu.parameterTable)
            : [];

          this.spuData = data;
          this.getSeat();
          this.bigImgSrc = res.data.sku.masterUrl;
          this.smallImgSrc = res.data.sku.masterUrl;
          this.prevShow = data.BannerImgList.length > 4 ? true : false;

          that.stateSche = 0;
        } else {
          that.stateSche = 2;
          that.$message({
            type: "error",
            message: res.message ? res.message : "商品查无数据！",
          });
        }
      });
    },
    // 8899
    getSeat() {
      let that = this;
      let categoryObj = this.categoryObj || {};
      let spuData = this.spuData;
      let objkey = Object.keys(categoryObj);
      if (spuData.spu && objkey && objkey.length) {
        let id = spuData.spu.category.split("/");
        let seatList = [];
        id.forEach((item) => {
          seatList.push(categoryObj[item].categoryName);
        });
        that.seatList = seatList;
      }
      // let that = this;
      // id = id.split("/");
      // let fristID = id[0];
      // let lastID = id[1];
      // getCategoryList().then((res) => {
      //   let seatList = [];
      //   let level_1 = res.data.find((item) => fristID == item.id);
      //   seatList.push(level_1.categoryName);

      //   if (
      //     level_1.subcategories &&
      //     level_1.subcategories.length > 0 &&
      //     lastID
      //   ) {
      //     let lalevel_2 = level_1.subcategories.find(
      //       (item) => lastID == item.id
      //     );

      //     lalevel_2 && seatList.push(lalevel_2.categoryName);
      //   }

      //   that.seatList = seatList;
      // });
    },

    //鼠标移入事件
    handlerMouseOver() {
      this.show = true;
    },
    //鼠标移出事件
    handlerMouseLeave() {
      this.show = false;
    },
    //鼠标移动事件
    handlerMouseMove(data) {
      const smallPic = document.getElementById("smallPic");
      const bigPic = document.getElementById("bigPic");
      const bigImg = document.getElementById("bigImg");
      const zoomTop = document.getElementById("zoomTop");
      const mask = document.getElementById("mask");
      //蒙版边界设置
      let left =
        data.clientX -
        smallPic.getBoundingClientRect().left -
        mask.offsetWidth / 2;
      let top =
        data.clientY -
        smallPic.getBoundingClientRect().top -
        mask.offsetHeight / 2;
      //边界判断
      if (left < 0) {
        left = 0;
      } else if (left > smallPic.clientWidth - mask.offsetWidth) {
        left = smallPic.clientWidth - mask.offsetWidth;
      }
      if (top < -1) {
        top = -1;
      } else if (top > smallPic.clientHeight - mask.offsetHeight) {
        top = smallPic.clientHeight - mask.offsetHeight;
      }
      mask.style.left = left + "px";
      mask.style.top = top + "px";
      let scale =
        (smallPic.clientWidth - mask.offsetWidth) /
        (bigImg.offsetWidth - bigPic.clientWidth);

      bigImg.style.left = -left / scale + "px";
      bigImg.style.top = -top / scale + "px";
    },
    //缩略图点击效果
    thumbnailClick(data, index) {
      this.bigImgSrc = data.masterUrl;
      this.smallImgSrc = data.masterUrl;
      this.imgActive = index;
    },
    //点击前一个
    handlerPrev() {
      if (!this.prevShow) {
        return;
      }
      let ul = document.querySelector("#goodsZoom #zoomBottom #picList ul");
      let liNodes = document.querySelectorAll(
        "#goodsZoom #zoomBottom #picList li"
      );
      if (liNodes.length === 0) {
        return;
      }
      //步长
      let step = (liNodes[0].offsetWidth + 20) * 2;
      this.start -= step;
      if (this.start < 0) {
        this.start = 0;
      }
      ul.style.left = -this.start + "px";
    },
    //点击下一个
    handlerNext() {
      if (!this.prevShow) {
        return;
      }
      let ul = document.querySelector("#goodsZoom #zoomBottom #picList ul");
      let liNodes = document.querySelectorAll(
        "#goodsZoom #zoomBottom #picList li"
      );
      if (liNodes.length === 0) {
        return;
      }
      //步长
      let step = (liNodes[0].offsetWidth + 20) * 2;
      //总体运动的距离值 = ul的宽度 - div框的宽度 = (图片的总数 - div中显示的数量) * （li的宽度 + 20）
      let endPosition = (liNodes.length - 5) * (liNodes[0].offsetWidth + 20);
      this.start += step;
      if (this.start > endPosition) {
        this.start = endPosition;
      }
      ul.style.left = -this.start + "px";
    },
  },

  watch: {
    categoryObj() {
      this.getSeat();
    },
  },
};
</script>

<style scoped lang="scss">
.topseat {
  background-color: #666;
  color: #fff;
  padding: 18px 0 18px 24px;
  margin-bottom: 50px;
  .el-icon-location-outline {
    margin-right: 4px;
  }
  .el-icon-arrow-right {
    margin: 0 10px;
  }
}
.container {
  margin: 5px 0 15px;
  overflow: hidden;

  #goodsZoom {
    width: 400px;
    text-align: center;
    margin-right: 60px;
    #zoomTop {
      width: 400px;
      position: relative;
      #smallPic {
        width: 398px;
        height: 398px;
        border: 1px solid #dfdfdf;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
        #mask {
          width: 200px;
          height: 200px;
          background: rgba(255, 255, 255, 0.5);
          border: 1px solid #ddd;
          position: absolute;
          left: 0px;
          top: -1px;
        }
      }

      #bigPic {
        margin-left: 4px;
        width: 400px;
        height: 400px;
        border: 1px solid #ddd;
        left: 400px;
        top: 0px;
        position: absolute;
        overflow: hidden;

        #bigImg {
          width: 1000px;
          height: 1000px;
          position: absolute;
          left: 0px;
          top: 0px;
        }
      }
    }

    #zoomBottom {
      margin-top: 5px;
      display: inline-block;
      a {
        float: left;
        text-decoration: none;
        color: #888;
        font-weight: 700;
        font-size: 24px;
        &:first-child {
          margin-right: 4px;
          margin-top: 18px;
        }
        .el-icon-caret-left {
          margin: 2px 2px 2px 0;
        }
      }
      .next {
        margin-top: 18px;
        .el-icon-caret-right {
          margin: 2px;
        }
      }
      #picList {
        width: 340px;
        height: 60px;
        float: left;
        overflow: hidden;
        position: relative;
        ul {
          white-space: nowrap;
          font-size: 0px;
          position: absolute;
          left: 0px;
          transition: 0.5s;
          li {
            width: 60px;
            height: 60px;
            padding: 2px;
            margin-right: 6px;
            display: inline-block;
            border: solid 1px transparent;
            cursor: pointer;

            img {
              width: 100%;
              height: 100%;
            }
          }
          .active {
            border-color: #ff0000;
          }
        }
      }
    }
  }

  .goodsWrods {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 30px 0 40px;

    .goodsName {
      color: #1788d8;
      font-size: 20px;
      margin-bottom: 21px;
    }
    .goodsRefer {
      font-size: 14px;
    }
    .oper {
      justify-content: space-between;
    }

    .btn {
      color: #fff;
      background-color: #333;
      line-height: 46px;
      width: 180px;
      border-radius: 18px;
    }

    .img {
      width: 28px;
      height: 28px;
      margin-right: 12px;
    }
  }
}

.goodsDetail {
  .title {
    font-size: 24px;
    justify-content: center;
    margin: 80px 0 30px;
  }
  .title::after,
  .title::before {
    content: "";
    display: inline-block;
    width: 60px;
    height: 3px;
    border-radius: 3px;
    margin: 0 8px;
    background-color: #333;
  }
}

@media (max-width: 650px) {
  .topseat {
    margin-bottom: 20px;
  }
  .container {
    flex-direction: column;
    align-items: center;
    padding: 0 30px;
    #goodsZoom {
      margin-right: 0;
      width: 100%;
      #zoomTop {
        width: 100%;
      }
      #smallPic {
        width: 100% !important;
        height: auto !important;
      }
    }

    #mask,#bigPic{
      visibility: hidden;
    }
  }

  .oper {
     margin-top: 13px;
  }
}
</style>